import { ticketClient } from "@/api/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { 
  GetDialerListParamReq, 
  GetDialerListReq, 
  SaveDialerReq, 
  Dialer, 
  DialerListOrder,
  GetDialerListOrderReq,
  SaveDialerListOrderReq
} from "@/pbjs/xcommon/ticket_pb";
// lee 绩效接口参数
interface Options {
  detail?: any;
  pageIndex: number;
  pageSize: number;
}
//  获取select选项配置
export function getDialerListParam(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetDialerListParamReq();
      request.setCommonin(setCommon());
      // setRank
      let _res = await ticketClient.getDialerListParam(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// 获取查询列表
export function getDialerList(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetDialerListReq();
      request.setCommonin(setCommon());
      // setRank
      let _res = await ticketClient.getDialerList(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// 获取dialer配置顺序
export function getDialerListOrder(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetDialerListOrderReq();
      request.setCommonin(setCommon());
      // request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      // setRank
      let _res = await ticketClient.getDialerListOrder(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// list新增、编辑
export function saveDialer(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new SaveDialerReq();
      request.setCommonin(setCommon());
      let requestDialer = new Dialer();
      requestDialer.setTicketaction(arg.detail.ticketaction);
      requestDialer.setPhoneobjects(arg.detail.phoneobject.join());
      requestDialer.setTicketorder(arg.detail.ticketorder);
      if(arg.detail.type === 2){
        requestDialer.setId(arg.detail.id);
        requestDialer.setStatus(arg.detail.status);
        requestDialer.setOpuid(arg.detail.opuid);
        requestDialer.setCtime(arg.detail.ctime);
        requestDialer.setUtime(arg.detail.utime);
      }
      request.setDetail(requestDialer);
      // setRank
      let _res = await ticketClient.saveDialer(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// 顺序配置保存
export function saveDialerListOrder(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new SaveDialerListOrderReq();
      request.setCommonin(setCommon());
      let requestDialer = new DialerListOrder();
      requestDialer.setItemid(arg.detail.itemid);
      requestDialer.setListid(arg.detail.listid);
      if(arg.detail.type){
        requestDialer.setId(arg.detail.id);
        requestDialer.setStatus(arg.detail.status);
        requestDialer.setOpuid(arg.detail.opuid);
        requestDialer.setCtime(arg.detail.ctime);
        requestDialer.setUtime(arg.detail.utime);
      }
      request.setData(requestDialer);
      // setRank
      let _res = await ticketClient.saveDialerListOrder(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}